const INVITATION_USER_ALREADY_EXISTS = 'INVITATION_USER_ALREADY_EXISTS';
const INVITATION_SENT = 'INVITATION_SENT';

export const INVITATION_RESPONSE = {
  userAlreadyExists: INVITATION_USER_ALREADY_EXISTS,
  invitationSent: INVITATION_SENT
};
